module.exports = __webpack_public_path__ + "img/eren-pfp.10270c49.png";